import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'sg-vraag',
  templateUrl: './vraag.component.html',
  styleUrls: ['./vraag.component.scss']
})
export class VraagComponent {

  contentScreen = false;
  @Input() vraagSoort: string;
  @Input() randomWelkeVraag: number;
  @Input() randomWelkeFotovraag: number;
  @Output() vraagChange = new EventEmitter();

  handelKeuzeSchermAf($event) {
    if ($event != null) {
      // VOLGENDE SPELER
      this.contentScreen = false;
      this.vraagChange.emit(true);
    } else {
      // ANNULEREN
      this.contentScreen = false;
      this.vraagChange.emit(null);
    }
  }

  closePopover() {
    this.vraagChange.emit(null);
  }
}
